import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-notice",
  "use": "icon-notice-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-notice\"><defs><style type=\"text/css\"></style></defs><path d=\"M839.850667 637.155556V434.631111c0-148.081778-110.250667-271.758222-257.763556-302.421333v-7.281778C582.087111 87.04 550.570667 56.888889 511.715556 56.888889S441.457778 87.552 441.457778 124.928v7.281778c-147.569778 30.663111-257.820444 153.770667-257.820445 302.364444v202.126222c0 32.711111-15.189333 61.269333-39.367111 79.985778-2.616889 2.104889-4.209778 3.128889-11.548444 8.305778a44.657778 44.657778 0 0 0-18.887111 36.920889c0 24.917333 21.048889 45.681778 46.705777 45.681778H863.573333a46.136889 46.136889 0 0 0 46.705778-45.681778 45.283556 45.283556 0 0 0-21.504-38.456889c-2.104889-1.024-2.673778-2.104889-4.209778-2.616889a100.522667 100.522667 0 0 1-44.657777-83.626667z m-211.057778 216.177777H394.638222c0 62.350222 52.508444 113.777778 117.077334 113.777778 64.625778 0 117.077333-50.915556 117.077333-113.777778z\" p-id=\"2723\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/notice.svg
// module id = MqGM
// module chunks = 102